
import { AuthenticationService } from "@/api";
import {
    AUTHENTICATION_LOGIN,
    AUTHENTICATION_LOGOUT,
    UITEXTS_FETCH_NS,
    PAGE_RESET_NS,
    ME_RESET_NS,
} from "@/store/actions.type";

import {
    FETCH_START,
    FETCH_END,
    SET_LOGIN,
    RESET_LOGIN,
} from "@/store/mutations.type";

const state = () => ({
    isLoading: false,
    token: localStorage.getItem('token') || '',
});

const actions = {

    async [AUTHENTICATION_LOGIN]({ commit, state, dispatch }, formData) {

        commit(FETCH_START);

        try {

            const { data: loginResponse } = await AuthenticationService.login(formData);
            if (loginResponse.success === false) {
                commit(FETCH_END);
                return {
                    success: false,
                    error: 'Login failed'
                };
            }

            const token = loginResponse.token;
            commit(SET_LOGIN, token);

            await dispatch(UITEXTS_FETCH_NS, true, { root: true });

            return {
                success: true,
                returnUrl: '/'
            };

        } catch(e) {
            console.log(e)
            commit(FETCH_END);
        }

        return {
            success: false,
            error: 'Error loggin in.'
        };
    },

    [AUTHENTICATION_LOGOUT]({ commit, dispatch }) {

        dispatch(PAGE_RESET_NS, null, { root: true });
        dispatch(ME_RESET_NS, null, { root: true });
        localStorage.removeItem('token');
        commit(RESET_LOGIN);


    },
};

const mutations = {

    [FETCH_START](state) {
        state.isLoading = true;
    },

    [FETCH_END](state) {
        state.isLoading = false;
    },

    [SET_LOGIN](state, token) {
        localStorage.setItem('token', token);

        state.token = token;
        state.isLoading = false;
    },

    [RESET_LOGIN](state, token) {
        state.token = '';
        state.isLoading = false;
    },
};

const getters = {
    isLoading: (state) => {
        return state.isLoading;
    },

    isLoggedIn: (state) => {
        return !!state.token;
    },

    getToken: (state) => {
        return state.token;
    }
};


export const authentication = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
